// extracted by mini-css-extract-plugin
export var copyIcon = "_rq-2";
export var discountCard = "_rq-0";
export var discountCode = "_rq-3";
export var discountContent = "_rq-1";
export var loadingCard = "_rq-4";